function createPlateBindingState(boundPlateNo) {
  const plateNo = typeof boundPlateNo === 'string' ? boundPlateNo.trim() : ''

  return {
    plateNo,
    isBound: Boolean(plateNo)
  }
}

function shouldBindPlateAfterPass({ isExit, isBound }) {
  return !isExit && !isBound
}

function shouldShowLoginCodeDebug({ enabled, loginCode }) {
  return (
    enabled === true &&
    typeof loginCode === 'string' &&
    Boolean(loginCode.trim())
  )
}

module.exports = {
  createPlateBindingState,
  shouldBindPlateAfterPass,
  shouldShowLoginCodeDebug
}
